<template>
  <div v-if="searchList.length && !loading" class="result-container">
    <button
      v-for="(item, idx) in searchList"
      :key="idx"
      :disabled="item.accountStatus !== 'Active'"
      type="button"
      :class="['result-item', item.accountStatus !== 'Active' ? 'disabled' : '']"
      @click="navigateTo(`/technician/${item.id}`)"
    >
      <span class="sac__font-14 med">
        {{ item.firstName + " " + item.lastName }} - {{ item.companyName }}
      </span>
      <span v-if="item.accountStatus !== 'Active'" class="sac-tag size-12 r-8 f-disabled">
        {{ item.accountStatus }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TechResultList',
  props: {
    searchList: Array,
    loading: Boolean,
  },
  methods: {
    navigateTo(url) {
      window.open(url, '_blank').focus();
    },
  },
};
</script>

<style scoped lang="scss">
.result-container {
  overflow-y: auto;
  margin-top: 1rem;
  display: grid;
  gap: 8px;
  scrollbar-width: none;
  .result-item {
    padding: 8px;
    gap: 1rem;
    display: grid;
    cursor: pointer;
    background-color: $N5;
    border-radius: 6px;
    grid-auto-flow: column;
    justify-content: space-between;
    align-items: center;
    &:hover {
      background-color: $N20;
    }
    &.disabled {
      cursor: not-allowed;
      &:hover {
        background-color: $N5;
      }
    }
  }

}
</style>
